//BAR GRAPH SCRIPT START
var chart = {};
$(document).ready(function () {
    if ($("#apply-filter").length) {
        $.ajax({
            method: "GET",
            url: "/sdg_filter",
            dataType: "json",
            success: function (data) {
                var select1 = "<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Region' name='project_region[]' multiple='multiple'>";
                $.each(data.project_region, function (key, value, index) {
                    select1 += '<option value="' + value.project_region + '">' + value.project_region + '</option>';
                });
                select1 += "</select></div>";
                $("#region-data").html(select1);


                var select2 = "<div class='multiselect-control-wrap'><select class='multiselect-control' data-placeholder='Select Value' name='project_state[]' multiple='multiple'>";
                $.each(data.project_state, function (key, value, index) {
                    select2 += '<option value="' + value.project_state + '">' + value.project_state + '</option>';
                });
                select2 += "</select></div>";
                $("#state-data").html(select2);
                $('.multiselect-control').multiselect({
                    includeSelectAllOption: true
                });
            }
        });
        $('.multiselect-control-checkbox').multiselect({
            includeSelectAllOption: true
        });
        $("#apply-filter").click(function () {
            $.ajax({
                method: "GET",
                url: "/sdg_ajax",
                dataType: "json",
                data: $('#filter').serialize(),
                success: function (data) {

                    makeChart(chart, data);

                }
            });
        });

        $.ajax({
            method: "GET",
            url: "/sdg_ajax",
            dataType: "json",
            success: function (data) {

                var graph_labels = [];
                var graph_data = [];

                $.each(data.result, function (key, value) {
                    graph_labels.push(value.sdg);
                    graph_data.push(value.goal);
                });
                
                Chart.defaults.global.legend.display = false;
                var ctx = document.getElementById('myChart').getContext('2d');
                chart = new Chart(ctx, { // The type of chart we want to create
                    type: 'bar',

                    // The data for our dataset
                    data: {
                        labels: graph_labels,
                        datasets: [
                            {
                                label: 'Sustainable Development Goals',
                                backgroundColor: [
                                    "#E5243B",
                                    "#DDA63A",
                                    "#4C9F38",
                                    "#C5192D",
                                    "#FF3A21",
                                    "#26BDE2",
                                    "#FCC30B",
                                    "#A21942",
                                    "#FD6925",
                                    "#DD1367",
                                    "#FD9D24",
                                    "#BF8B2E",
                                    "#3F7E44",
                                    "#0A97D9",
                                    "#3eaf49",
                                    "#00689D",
                                    "#19486A"
                                ],
                                borderColor: 'rgb(255, 99, 132)',
                                data: graph_data
                            }
                        ]
                    },

                    // Configuration options go here
                    options: {
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    ticks: {
                                        fontSize: 40
                                    },
                                    display: false,
                                    drawBorder: false
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    display: false,
                                    fontSize: 40
                                },
                                gridLines: {
                                    display: false,
                                    drawBorder: false
                                }
                            }]
                        }
                    }
                });
                Chart.defaults.global.defaultFontFamily = 'Quicksand-Medium';
                Chart.defaults.global.defaultFontSize = 16;
            }
        });
    }

});

function makeChart(chart, data) {

    var graph_labels = [];
    var graph_data = [];

    $.each(data.result, function (key, value) {
        graph_data.push(value.goal);
    });
    chart.config.data.datasets[0].data = graph_data;
    chart.update();
}
//BAR GRAPH SCRIPT STARTEND
